import { useMemo } from 'react';

import { CareServiceOrgansKey } from '@/api';
import { useFindingsByOrgan } from '@/shared/hook';
import { ReportLink } from '@/shared/model';
import { getFindingsWithHighScores, isNotEmpty, mergeFindings } from '@/shared/util';
import { useReportValidationStore } from '@/store';

export function useEvaluateLinks(links: ReportLink[]): () => void {
  const { defaultFindings, findings } = useFindingsByOrgan();

  const getStatus = useReportValidationStore((state) => state.getStatus);
  const setStatus = useReportValidationStore((state) => state.setStatus);

  const mergedFindings = useMemo(
    () => mergeFindings(links, defaultFindings, findings),
    [defaultFindings, findings, links],
  );
  const highScoreOrgans = useMemo(
    () => getFindingsWithHighScores(mergedFindings),
    [mergedFindings],
  );

  return () =>
    links.forEach(({ key, sub }) => {
      const organState = getStatus(key);
      const organWarning = Boolean(highScoreOrgans[key as CareServiceOrgansKey]?.length);

      if (isNotEmpty(sub)) {
        sub.forEach(({ key: subKey }) => {
          const subOrganState = getStatus(subKey);
          const hasSubOrganWarning = Boolean(
            highScoreOrgans[subKey as CareServiceOrgansKey]?.length,
          );

          setStatus(subKey, {
            ...subOrganState,
            done: subOrganState?.done ?? false,
            error: subOrganState?.error ?? false,
            warning: hasSubOrganWarning,
          });
        });
      }

      setStatus(key, {
        ...organState,
        done: organState?.done ?? false,
        error: organState?.error ?? false,
        warning: organWarning,
      });
    });
}
